<template>
    <ValidationProvider
        :disabled="true"
        v-slot="{ classes, errors }"
        :rules="rules"
        :custom-messages="customMessages"
        :class="$attrs['class']"
        class="w-full"
        :name="name"
        ref="provider"
        :vid="name"
        tag="div"
    >
    <div class="w-full mb-5" v-if="tooltip">
        <tooltip>
            <div v-html="tooltip"></div>
        </tooltip>
    </div>
    <div class="digi-multi-checkbox w-full">
        <label
            class="form-label"
            :for="name"
            v-html="label"
            tabindex="0"
        ></label> 
        <div class="form-input yes-no-checkbox" :class="classes" id="consent-v2">
            <div
                v-for="(v, k) in options" 
                :key="k" 
                tabindex="-1"
                :data-value="k"
                class=" flex align-middle inner  option flex-col flex-grow-0 appearance-none border-0 outline-none items-stretch relative"
            >
                <div class="container flex justify-between items-center bg-white border border-gray-500 border-solid text-sm w-full" >
                    <div class="flex w-2/3 items-center">
                        <img class="icon-img" :src="v.icon" :alt="`${v.label} icon`">
                        <span v-html="v.label"></span>
                    </div>  
                    <div class="flex justify-around w-1/3">
                        <button class="bg-transparent " :class="{'response-active' : values.includes(k)}" :data-value="k" type="button" tabindex="-1" @click="toggleCheckbox(k, true)">
                            <span :class="{'text-green-500': values.includes(k)}">Yes</span>
                            <input type="checkbox" name="yes" class="hidden" :value="k" v-model="values">
                        </button>
                        <button class="bg-transparent " :class="{'response-active' : clickedOptions[k] === 'no' }" type="button" tabindex="-1" @click="toggleCheckbox(k, false)">
                            <span :class="{'text-green-500': clickedOptions[k] === 'no' }">No</span>
                            <input type="checkbox" name="no" class="hidden" value="">
                        </button>
                    </div>
                </div>
            </div>
        </div> 
        <div
            v-if="microtext"
            class="form-microtext text-xs font-bold text-gray-700 mt-2"
            v-html="microtext"
        ></div>
    </div>
    </ValidationProvider>
</template>
<script>
import { isArray, has } from "underscore"

import { fireFullStoryFieldChangeEvent } from '../../assets/js/fullstory-helper'
import Tooltip from './tooltip'
export default {
    components: {
        tooltip: Tooltip,
    },
    data() {
        return {
            values: isArray(this.value) ? this.value : [],
            clickedOptions: {},
        } 
    },
    props: {
        validationDisabled: {
        type: Boolean,
        default: false
        },
        focusOnNext: {
            type: Boolean,
            default: true,
        },
        type: {
            default: 'normal',
        },
        rules: {
            default: () => {
                return {}
            },
        },
        customMessages: {
            default: () => {
                return {}
            },
        },
        options_per_row: {
            default: 3,
        },
        show: {
            default: true,
        },
        value: {
            default: null,
        },
        name: {
            default: '',
        },
        label: {
            default: '',
        },
        options: {
            default: () => {
                return {}
            },
            type: Object,
        },
        valid: {
            default: null,
        },
        microtext: {
            default: null,
        },
        tooltip: {
            default: null,
        },
    },
    watch: {
        values: {
            deep: true,
            immediate: true,
            handler(){
                this.$emit('input', this.values);
                this.$emit('change', this.values);    
            }
        }
    },
    methods: {
        updateValue(value) {
            // this.thisValue = value;
            fireFullStoryFieldChangeEvent(this.name, value);
        },
        handleClick(value, e) {
            // this.updateValue(value);
            // if (this.$refs.provider) {
            //     this.$refs.provider.validate(value).then((result) => {
            //     });
            // }
            // this.$emit('input', this.thisValue);
            // this.$emit('change', this.thisValue);
        },
        toggleCheckbox(value, isYes) {
            if (isYes) {
                if (!this.values.includes(value)) {
                    this.values.push(value);
                }
                this.$set(this.clickedOptions, value, 'yes');
            } else {
                const index = this.values.indexOf(value);
            if (index > -1) {
                // Use slice to remove the value
                this.values = [...this.values.slice(0, index), ...this.values.slice(index + 1)];
            }
                this.$set(this.clickedOptions, value, 'no');
            }
            this.updateValue(this.values);
        },

        updateValue(value) {
            fireFullStoryFieldChangeEvent(this.name, value);
        },
    },
}
</script>

<style lang="scss" scoped>
.p-5px {
    padding: 5px;
}
.checkbox-container {
    margin: 0 -5px 0 -5px;
}
.container {
    &.active {
        box-shadow: inset 0 0 0 1px #3dcfaf;
        border-color: #3dcfaf;
        border-width: 1px;
    }
}
.checkbox input[type=checkbox], .checkbox input[type=radio] {
    float: left;
    position: relative;
    top: -4px;
    margin-right: 6px;
    @screen md {
        margin-right: 18px;
    }
}
.checkbox-round {
    height: 18px;
    width: 18px;
    background: #FFFFFF;
    border-radius: 100%;
    appearance: none;
    outline: none;
    cursor: pointer;
    &:focus {
        outline: none!important;
    }
    &:active {
        border: 1px solid #3dcfaf;
    }

    &::before { 
        transition: opacity .15s ease-in-out;
        opacity: 0;
        content: '';
        position: absolute;
        display: block;
        height: 10px;
        width: 10px;
        border-radius: 20px;
        background-color: #3dcfaf;
        margin: 3px;
    }

    &:checked {
        border: 1px solid #3dcfaf;
        &::before {
            opacity: 1;
        }
    }
}
.checkbox {
    .container {
        display: block;
        position: relative;
        padding-left: 25px;
        @screen md {
            padding-left: 35px;
        }
        cursor: pointer;
        min-height: 50px;
        border-radius: 6px;
        text-align: left;
        padding-top: 15px;
    }
}
.yes-no-checkbox {
    .container {
        font-weight: 500;
        padding: 0 20px 0 20px;
        margin: 5px 0 5px 0; 
        @media (min-width: 640px) {
            padding:0 35px 0 35px ;
        }
        height: 62px;
        border-radius: 6px;
        .icon-img {
            width: 30px;
            height: 30px;
            margin-right: 20px;
        }
    }
}

.response-active{
border-bottom: #3dcfaf 1px solid;
height: 60px;
}
</style>